import type { ModelFacade } from "./ModelFacade"
import { inject } from "vue"
import { MODEL_INJECTION_KEY } from "./token"

export * from "./auth"
export * from "./ModelApi"
export * from "./ModelFacade"
export type * from "./plugin"
export { default as useEngineModelPlugin } from "./plugin"
export * from "./token"
export * from "./types"

export function useEngineModel(): ModelFacade {
  return inject(MODEL_INJECTION_KEY) as ModelFacade
}
